import { queryClient } from "@verbleif/lib/src/composables/Query/queryClient";
import { itemKey } from "../Query/resourceKeys";
import { api } from "./api";

export async function loadItem(modelValue: any) {
  if (typeof modelValue !== "string") {
    return null;
  }
  if (!modelValue.startsWith("/api/")) {
    return null;
  }

  return queryClient.fetchQuery({
    queryKey: itemKey(modelValue),
    queryFn: () => api.get<object>(modelValue).then(r => r.data),
    staleTime: 30_000,
  });
}
